import React from 'react';
const Delete = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7" fill="#E2E2E2" />
      <rect
        x="10.8271"
        y="5.87744"
        width="7"
        height="1"
        rx="0.5"
        transform="rotate(135 10.8271 5.87744)"
        fill="#666666"
      />
      <rect
        x="10.124"
        y="10.8267"
        width="7"
        height="1"
        rx="0.5"
        transform="rotate(-135 10.124 10.8267)"
        fill="#666666"
      />
    </svg>
  );
};

export default Delete;
